import { Outlet } from 'react-router-dom';
import SidebarDoc from './SidebarDoc';

type Props = {}

const DocPage = (props: Props) => {
  return (
    <div className="flex flex-grow">
      <SidebarDoc />
      <div className="flex-1 p-6">
        <Outlet /> 
      </div>
    </div>
  );
}

export default DocPage;